import React, { useContext, useState } from "react";
import { Field, Intro, Text, SearchField } from "components/commons";
import { Skeleton } from "@material-ui/lab";
import { StationContext } from "contexts";
import { getKeyAccountListApi } from "apis";
import { useApi, useMountAsync } from "hooks";
import { ConfirmModal } from "components/modals";
import styles from "./select-key-account-modal.module.scss";
import locale from "localization";

const SelectKeyAccountModal = ({ type = "", onSelect, ...modal }) => {
  const { station } = useContext(StationContext);
  const [searchKey, setSearchKey] = useState("");
  // eslint-disable-next-line
  const [selectedId, setSelectedId] = useState(null);

  const {
    request,
    loading,
    result = { keyAccounts: [], count: 0 },
  } = useApi({
    api: getKeyAccountListApi,
    params: {
      stationCode: station.stationCode,
    },
    pageError: true,
  });

  useMountAsync(async () => {
    await request({ page: 1, perPage: 9999 });
  });

  const handleSearch = (value) => {
    setSearchKey(value.toLowerCase());
  };

  const handleClear = () => {
    setSearchKey("");
  };

  const handleSelect = (keyAccount) => {
    setSelectedId(keyAccount.keyAccountId);
    onSelect?.(keyAccount);
    modal.close();
  };

  const filtered = result.keyAccounts.filter((keyAccount) => {
    if (searchKey === "") {
      return result.keyAccounts;
    }
    return type === "name"
      ? keyAccount.name.toLowerCase().includes(searchKey)
      : keyAccount.code?.toLowerCase().includes(searchKey);
  });

  const sortList = (array, size) =>
    Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size)
    );

  const renderTiles = () => {
    if (loading) return <Skeleton height={100} />;

    const rows = sortList(filtered, 4);

    return (
      <div className={styles.container}>
        {rows.map((row, i) => (
          <div key={i} className={styles.row}>
            {row.map((keyAccount) => (
              <div
                key={keyAccount.keyAccountId}
                className={styles.tile}
                onClick={() => handleSelect(keyAccount)}
              >
                <Text className={styles.value}>
                  {type === "name" ? keyAccount.name : keyAccount.code}
                </Text>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <ConfirmModal {...modal} hideActions={true}>
      <div className={styles.modal}>
        <Intro
          title={type === "name" ? locale.selectKeyAccountName : locale.selectKeyAccountCode}
        />
        <Field className={styles.search}>
          <SearchField
            value={searchKey}
            placeholder={type === "name" ? locale.enterKeyAccountName : locale.enterKeyAccountCode}
            onChange={(_, { value }) => handleSearch(value)}
            searchWithSymbols={false}
            restrict={false}
            onClear={handleClear}
          />
        </Field>
        {renderTiles()}
      </div>
    </ConfirmModal>
  );
};

export default SelectKeyAccountModal;
